<template>
  <div
    v-if="loading"
    class="ma-5 text-xs-center"
  >
    <v-progress-circular
      indeterminate
      :size="32"
      color="accent"
    />
  </div>
  <div
    v-else
    layout="column"
  >
    <div
      layout="row"
      layout-align="start center"
    >
      <span class="subheading ml-2 mr-3">Sessions per trainers (status up to 'validate')</span>

      <v-checkbox
        v-model="is_enabled"
        hide-details
        prepend-icon="mdi-lock-open"
        :true-value="1"
        :false-value="null"
        label="Trainers enabled only"
        class="mt-0 pt-0"
        style="display: contents"
        @change="fetchTrainers"
      />
      <span class="mx-2" />
      <v-checkbox
        v-model="is_enabled"
        hide-details
        prepend-icon="mdi-lock"
        :true-value="0"
        :false-value="null"
        label="Trainers disabled only"
        class="mt-0 pt-0"
        style="display: contents"
        @change="fetchTrainers"
      />
    </div>
    <v-data-table
      :headers="headers"
      :items="sessions"
      style="max-width: 1000px"
      hide-actions
    >
      <template
        slot="items"
        slot-scope="{ item }"
      >
        <td>{{ item.label }}</td>
        <td>{{ item.nb_sessions }}</td>
        <td>{{ item.hours }}</td>
        <td>{{ item.hours_per_session }}</td>
      </template>
    </v-data-table>

    <div
      layout="row"
      layout-align="start center"
      class="mt-2"
    >
      <span class="subheading ml-2 mr-3">Sessions per type</span>
      <v-checkbox
        v-model="is_enabled_type"
        hide-details
        prepend-icon="mdi-lock-open"
        :true-value="1"
        :false-value="null"
        label="Trainers enabled only"
        class="mt-0 pt-0"
        style="display: contents"
        @change="fetchTypes"
      />
      <span class="mx-2" />
      <v-checkbox
        v-model="is_enabled_type"
        hide-details
        prepend-icon="mdi-lock"
        :true-value="0"
        :false-value="null"
        label="Trainers disabled only"
        class="mt-0 pt-0"
        style="display: contents"
        @change="fetchTypes"
      />
    </div>
    <v-data-table
      :headers="headers_types"
      :items="session_types"
      style="max-width: 1000px"
      hide-actions
    >
      <template
        slot="items"
        slot-scope="{ item }"
      >
        <td>{{ item.label }}</td>
        <td
          v-for="t in types"
          :key="t.value"
        >
          {{ item.session_types[t.value] ? item.session_types[t.value] : 0 }}
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Statistics from '@/api/statistics'
import Consts from '@/consts'
import SessionsMixin  from '@/mixins/sessions'

export default {
  mixins: [SessionsMixin],
  props: ['start', 'end', 'application', 'toFilter'],
  data () {
    return {
      sessions: [],
      session_types: [],
      headers: [
        { text: '', value: 'topic', sortable: false },
        { text: 'Sessions', value: 'nb_sessions', sortable: false },
        { text: 'Hours', value: 'hours', sortable: false },
        { text: 'h / session', value: 'hours_per_session', sortable: false }
      ],
      loading: false,
      events: Consts.EVENTS,
      school: Consts.SCHOOL,
      adults: Consts.ADULTS,
      teachers: Consts.TEACHERS,
      youth: Consts.YOUTH,
      other: Consts.OTHER,
      internal: Consts.INTERNAL,
      internal_as: Consts.INTERNAL_AS,
      is_enabled: null,
      is_enabled_type: null
    }
  },
  computed: {
    headers_types () {
      let arr = [
        { text: '', sortable: false }
      ]

      this.types.forEach(l => {
        arr.push({text: l.text, sortable: false})
      })

      return arr
    },
    types () {
      if(this.application == Consts.APPLICATION.FREELANCES){
        return [
          {
            value: Consts.FREELANCES_TRAINING,
            text: this.sessionTypeStrLong(Consts.FREELANCES_TRAINING)
          },
          {
            value: Consts.FREELANCES_REFRESH_TRAINING,
            text: this.sessionTypeStrLong(Consts.FREELANCES_REFRESH_TRAINING)
          },
          {
            value: Consts.ACTIVITY,
            text: this.sessionTypeStrLong(Consts.ACTIVITY)
          },
          {
            value: Consts.INTRODUCTION_DAY,
            text: this.sessionTypeStrLong(Consts.INTRODUCTION_DAY)
          },
          {
            value: Consts.INTERNAL_AS,
            text: this.sessionTypeStrLong(Consts.INTERNAL_AS)
          }
        ];
      } else {
        return [
          {
            value: Consts.EVENTS,
            text: this.sessionTypeStrLong(Consts.EVENTS)
          },
          {
            value: Consts.ADULTS,
            text: this.sessionTypeStrLong(Consts.ADULTS)
          },
          {
            value: Consts.SCHOOL,
            text: this.sessionTypeStrLong(Consts.SCHOOL)
          },
          {
            value: Consts.TEACHERS,
            text: this.sessionTypeStrLong(Consts.TEACHERS)
          },
          { value: Consts.YOUTH, text: this.sessionTypeStrLong(Consts.YOUTH) },
          {
            value: Consts.INTERNAL,
            text: this.sessionTypeStrLong(Consts.INTERNAL)
          },
          { value: Consts.OTHER, text: this.sessionTypeStrLong(Consts.OTHER) },
          { value: Consts.INTRODUCTION_DAY, text: this.sessionTypeStrLong(Consts.INTRODUCTION_DAY) }
        ];
      }
    }
  },
  watch: {
    toFilter (val) {
      if (val) {
        this.fetch()
        this.$emit('update:toFilter', false)
      }
    }
  },
  mounted () {
    this.fetch()
  },
  methods: {
    fetch () {
      this.fetchTrainers()
      this.fetchTypes()
    },
    fetchTrainers () {
      this.loading = true
      Statistics.getSessionsTrainers({ start: this.start, end: this.end, is_enabled: this.is_enabled, application: this.application }).then(res => {
        this.sessions = res.data
        this.loading = false
      })
    },
    fetchTypes () {
      this.loading = true
      Statistics.getSessionTypesTrainers({ start: this.start, end: this.end, is_enabled: this.is_enabled_type, application: this.application }).then(res => {
        this.session_types = res.data
        this.loading = false
      })
    }
  }
}
</script>
<style scoped>
.number-color {
  color: #f4b944;
}
</style>
